export const AW_BFF_API_URL = process.env?.AWAPI_AWBFF_URL || '/aw-bff';
export const AW_BFF_API_URL_AGRAPH = process.env?.AWAPI_AWBFF_URL_AGRAPH || '/api/wealth/legacy/aw-bff/v1';
export const LOG_URL = '/event-logger/log';
